import React from 'react';
import { motion } from 'framer-motion';
import { TiltPortrait } from './TiltPortrait';

const STATS = [
  ['10+', 'anos construindo marcas'],
  ['5,0', 'nota no Google'],
  ['24h', 'para o seu Raio-X'],
];

export const AboutAnderson = () => (
  <section id="sobre" className="relative py-28 sm:py-40 overflow-hidden" data-testid="about-section">
    <div className="absolute right-[-15%] top-1/3 h-[500px] w-[500px] rounded-full bg-[#D9A85B]/10 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-[0.8fr_1.2fr] gap-16 lg:gap-24 items-center">
      <div className="max-w-sm w-full mx-auto lg:mx-0 order-2 lg:order-1">
        <TiltPortrait src="/images/anderson-camera.jpg" alt="Anderson Coutinho com câmera profissional" testId="about-portrait" position="object-[50%_75%] scale-110" />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.8 }}
        className="order-1 lg:order-2"
      >
        <p className="br-mono text-[11px] text-[var(--br-teal)]">Quem está por trás</p>
        <h2 className="mt-5 text-3xl sm:text-5xl font-semibold leading-tight">
          Estratégia de quem pensa o negócio. <span className="italic text-[var(--br-teal)]">Olhar de quem domina a câmera.</span>
        </h2>
        <div className="mt-8 space-y-5 text-base sm:text-lg text-[var(--br-muted)] leading-relaxed max-w-2xl">
          <p>Sou Anderson Coutinho, fundador da Coutin. Há mais de uma década ajudo empresas a se posicionarem como referência, unindo estratégia de marca e produção audiovisual.</p>
          <p>Hoje atendo hotéis, veículos de jornalismo, operadoras de turismo, restaurantes, eventos e profissionais que querem ser vistos pelo valor que entregam. Você fala comigo, do diagnóstico à entrega.</p>
        </div>
        <dl className="mt-12 grid grid-cols-3 gap-4 max-w-xl">
          {STATS.map(([n, l]) => (
            <div key={l} className="border-t border-white/15 pt-5" data-testid={`stat-${n}`}>
              <dt className="br-serif text-4xl sm:text-5xl font-semibold text-white">{n}</dt>
              <dd className="mt-2 text-xs sm:text-sm text-[var(--br-muted)]">{l}</dd>
            </div>
          ))}
        </dl>
      </motion.div>
    </div>
  </section>
);
